import React from "react"

import { FEATURES_TYPE, BI_ROUTES } from "@constants"
import AppLayout from "Layout"
import { BUSINESS_LOGISTICS_ROUTES } from "@constants/routes"
import EuropcarPricingEnvironmentPage from "./PricingEnvironment/Page";
import EuropcarAnalyticsPage from "./Analytics/Page";
import BIPage from "./BI/Page";
import LeadingAnalyzerPage from "./LeadingAnalyzer/Page";
import { Navigate } from "react-router-dom";


export const BusinessLogisticsRoutes = userData => {
	const europcarRoutes = userData?.featuresV2?.europcar ? [
		{
			path: BUSINESS_LOGISTICS_ROUTES.EUROPCAR_PATH,
			title: 'Europcar Custom Search Analytics',
			element: <EuropcarAnalyticsPage/>,
		},
		{
			path: BUSINESS_LOGISTICS_ROUTES.PRICING_ENV_PATH,
			title: BUSINESS_LOGISTICS_ROUTES.PRICING_ENV_TITLE,
			element: <EuropcarPricingEnvironmentPage/>
		}
	] : []

	const biRoutes = userData?.featuresV2?.bi ? [
		{
			path: BUSINESS_LOGISTICS_ROUTES.BI_PATH,
			title: BUSINESS_LOGISTICS_ROUTES.BI_TITLE,
			element: <BIPage/>,
		}
	] : []

	const leadingAnalyzerRoutes = userData?.featuresV2?.leading_price ? [
		{
			path: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_PATH,
			title: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_TITLE,
			element: <LeadingAnalyzerPage/>,
		}
	] : []

	const children = [...europcarRoutes, ...biRoutes, ...leadingAnalyzerRoutes]
	
	if (children.length > 0) {
		return [{
			id: FEATURES_TYPE.COMMON,
			path: BUSINESS_LOGISTICS_ROUTES.PATH,
			title: BUSINESS_LOGISTICS_ROUTES.TITLE,
			icon: 'chart-line',
			element: <AppLayout/>,
			children: [{
				element: <Navigate to={children[0].path} replace/>, index: true
			}, ...children]
		}]
	}
	
	return []
}